import React from 'react';
import { useParams } from 'react-router-dom';
import { PageParams } from '../types/PageParams';
import useOpportunitySivaContract from '../hooks/use-opportunity-siva-contract';
import ContactInfo from '../components/OpportunityOverview/ContactInfo';
import ReferredFrom from '../components/OpportunityOverview/ReferredFrom';
import ActorsWithAccess from '../components/OpportunityOverview/ActorsWithAccess';
import SivaContractInfo from '../components/OpportunityOverview/SivaContractInfo';
import OwiFormOverview from '../components/OpportunityOverview/OwiFormOverview';
import CustomerOtherOpportunities from '../components/OpportunityOverview/CustomerOtherOpportunities';
import OpportunityFeedback from '../components/OwiReferralFeedback/OpportunityFeedback';
import { useCluster } from 'src/features/cluster';
import useOneWayIn from '../../hooks/use-one-way-in';
import useOneWayInFeedback from 'src/features/one-way-in/hooks/use-one-way-in-feedback';
import useFeedbackMissing from 'src/features/one-way-in/hooks/use-feedback-missing';

const OpportunityOverview = () => {
  const { formId } = useParams<PageParams>();
  const { cluster } = useCluster();
  const { hasSivaContract } = useOpportunitySivaContract(formId);
  const { oneWayInOpportunityById, onewWayInOpportunityFormINResponseMailQuery } = useOneWayIn(formId);
  const { opportunityFeedbackCollection, isLoading: isLoadingFeedback } = useOneWayInFeedback(formId);
  const feedbackMissing = useFeedbackMissing(opportunityFeedbackCollection, oneWayInOpportunityById.data);
  const isAutomaticallyReferred = onewWayInOpportunityFormINResponseMailQuery.data?.isAutomaticReply;

  return (
    <div className="display--flex flex-direction--column">
      <div className="display--flex flex-direction--column gap--ds-6">
        <div className="opportunity-overview--cards">
          <ContactInfo />
          <ReferredFrom />
          <ActorsWithAccess />
          {hasSivaContract && <SivaContractInfo />}
        </div>
        <div className="display--flex width--40 flex-direction--column gap--4">
          <OwiFormOverview />
          {feedbackMissing &&
            !onewWayInOpportunityFormINResponseMailQuery.isLoading &&
            !isLoadingFeedback &&
            !isAutomaticallyReferred && (
              <OpportunityFeedback
                formId={formId}
                opportunity={oneWayInOpportunityById.data}
                cluster={cluster}
              />
            )}
          <CustomerOtherOpportunities />
        </div>
      </div>
    </div>
  );
};

export default OpportunityOverview;
